import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';

/**
 * Representa un SxSoc_Historial en el backend
 */
export interface Historial {
  id: number;
  comentario: string;
  data: any;
  entidad: string;
  fecha: Date;
  idEntidad: string;
  usuario: string;
  version: number;
}

@Injectable()
export class HistorialService {
  private url = 'api/historial';

  constructor(private sxHttp: SxHttpService) { }

  /**
   * Obtiene el historial de una entidad
   */
  getHistorial(entidad: string, entidadId: string): Observable<Historial[]> {
    const url = `${this.url}/${entidad}/${entidadId}`;

    return this.sxHttp.get(url)
      .map(response => response.json().data as Historial[])
      .map(historial => {
        return historial.map(current => ({ ...current, data: JSON.parse(current.data || '') }));
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/historial.service.ts